export const transformDifferenceValue = (value: number | undefined) => {
    if (!value) return '0';
    if (value > 0) return `+${value}`;
    if (value <= 0) return `${value}`;
    return `${value}`;
};
